<template>
  <div class="tuolele-main-box set-combo">
    <div class="tuolele-main-search">
      <el-row type="flex" justify="space-between">
        <el-form :inline="true" :model="search">
          <el-form-item label="店铺名称">
            <Select key="1" :selected.sync="search.shop_id" :data="shopLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="类型">
            <Select key="2" :selected.sync="search.testing_id" :data="typeLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="状态">
            <Select key="3" :selected.sync="search.status" :data="statusLists" clearable placeholder="请选择" />
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="fnGetLists()">查询</el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </div>
    <div class="tuolele-main-content">
      <el-table :data="tableData" border stripe>
        <el-table-column prop="shop_name" label="店铺" />
        <el-table-column prop="testing_name" label="类型" />
        <el-table-column prop="status_name" label="状态" />
        <el-table-column prop="modify_time" label="更新时间" />
        <el-table-column prop="editor_name" label="检查人" />
        <el-table-column prop="confirm_name" label="确认人" />
        <el-table-column prop="appeal" label="申诉内容" />
      </el-table>
    </div>
  </div>
</template>
<script>
import Select from '@/components/Select'

export default {
  name: 'StoreSetting',
  components: {
    Select
  },
  data() {
    return {
      dialogVisible: false,
      search: {
        testing_id: '',
        shop_id: '',
        status: ''
      },
      typeLists: [],
      tableData: [],
      shopLists: [],
      photoSelect: [{
        id: 1,
        name: '无需拍照'
      },
      {
        id: 2,
        name: '需拍照'
      }],
      statusLists: []
    }
  },
  mounted() {
    this.fnGetLists()
    this.fnGetSelectList()
  },
  methods: {
    fnGetLists() {
      this.$http.getQualityTestingRecordList(this.search).then(res => {
        this.tableData = res.data.list;
        (res.data.type_list || []).forEach((ele) => {
          ele.id = ele.testing_id
          ele.name = ele.testing_name
        })
        this.statusLists = res.data.status_info
        this.typeLists = res.data.type_list
      })
    },
    fnGetSelectList: function() {
      this.$http.getMyShopList().then(res => {
        this.shopLists = res.data
      })
    }

  }
}
</script>
<style lang="scss">
  .wq_flex {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
  }

  .wq_flex_wrap {
    flex-wrap: wrap;
  }

  .wq_flex_sub {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
  }

  .set-combo {
    .self-table {
      margin-top: 0 !important;
    }
    .el-form-item__label {
      font-size: 16px;
      color: #333;
    }
    .el-form-item__content {
      margin: 0 20px 0 12px;
    }
    .el-button.el-button-confirm {
      width: 80px !important;
    }
  }
</style>
